import { render, staticRenderFns } from "./TwBenchmarkPostDetailDrawer.vue?vue&type=template&id=39b59327&scoped=true"
import script from "./TwBenchmarkPostDetailDrawer.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkPostDetailDrawer.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkPostDetailDrawer.vue?vue&type=style&index=0&id=39b59327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b59327",
  null
  
)

export default component.exports